
export function is_event_inside_element_with_id(event, element_id) {

    const container = document.getElementById(element_id);

    if (container) {
      // Get the position and dimensions of the container
      const rect = container.getBoundingClientRect();

      // Get the global position of the mouse by adding the scroll offset
      const globalX = event.clientX + window.scrollX;
      const globalY = event.clientY + window.scrollY;

      // Check if the global mouse position is inside the container's bounding box
      const isInside = 
        globalX >= rect.left + window.scrollX &&
        globalX <= rect.right + window.scrollX &&
        globalY >= rect.top + window.scrollY &&
        globalY <= rect.bottom + window.scrollY;

      // If it's inside, do nothing (return early)
      if (isInside) {
        return true;
      }
    }
    
    return false;
}